"use client";

import { IsovBodyCta } from "@/components/stencil";

interface SectionPlaceholderProps {
  theme?: string;
  eyebrow?: string;
  title?: string;
  description?: string;
  decorated?: boolean;
  shaded?: boolean;
  skeleton?: boolean;
}

export default function SectionPlaceholder({
  theme,
  eyebrow,
  title,
  description,
  decorated,
  shaded,
  skeleton,
}: SectionPlaceholderProps) {
  return (
    <IsovBodyCta
      theme={theme}
      eyebrow={eyebrow}
      headline={title}
      subtext={title}
      decorated={decorated}
      shaded={shaded}
      skeleton={skeleton}
    >
      <p className="mb-0">{description}</p>
    </IsovBodyCta>
  );
}
